// @flow
import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import WorkspaceNav from './WorkspaceNav';
import { WorkspaceUIContext } from './context/WorkspaceUIContext';
import Sidebar from './Sidebar';
const useStyles = makeStyles((theme) => ({
    container: {
        position: 'relative',
        padding: 40,
    },
}));
const Workspace = () => {
    const [sidebarView, setSidebarView] = useState();
    const classes = useStyles();
    const handleSetSidebarView = (view) => setSidebarView(view);
    return (React.createElement(WorkspaceUIContext.Provider, { value: {
            setSidebarView: handleSetSidebarView,
            sidebarView,
        } },
        React.createElement("div", { className: classes.container },
            React.createElement(WorkspaceNav, null)),
        React.createElement(Sidebar, null)));
};
export default Workspace;
